import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { CUSTOM_ELEMENTS_SCHEMA, DoBootstrap, Injector, NgModule } from '@angular/core';
import { createCustomElement } from '@angular/elements';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

// Modules
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { CoreModule } from '@app/core/core.module';
import { DialogModule } from 'primeng/dialog';

// Services
import { InboundFaxMfeService, PlatformService } from '@app/core/service';

// Components
import { InboundFaxesComponent } from './pages/inbound-faxes/inbound-faxes.component';

import { GATEWAY_URL, PLATFORM_API_URL } from '@app/core/constants';
import { environment } from '@env/environment';
import {
  PrimeNGConfigLoader,
  providePrimeNGFromShell,
  RouteInterceptor,
  ShellService,
  TokenInterceptor
} from '@mynexus/mfe-core';

/**
 * MFE-specific default theme loader. Lazy-loads `@mynexus/theme` so the Carelon
 * preset is only fetched when the shell hasn't supplied its own theme.
 */
const loadCarelonPrimeNGConfig: PrimeNGConfigLoader = async () => {
  const { Carelon, CSS_LAYERS_ORDER } = await import('@mynexus/theme');

  return {
    ripple: false,
    theme: {
      preset: Carelon,
      options: {
        darkModeSelector: false,
        cssLayer: {
          name: 'primeng',
          order: CSS_LAYERS_ORDER
        }
      },
    }
  };
};

@NgModule({
  declarations: [],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    CoreModule,
    ReactiveFormsModule,
    InboundFaxesComponent,
  ],
  exports: [...environment.modules],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: RouteInterceptor,
      multi: true,
    },
    {
      provide: PLATFORM_API_URL,
      useValue: environment.platformApiUrl,
    },
    {
      provide: GATEWAY_URL,
      useValue: environment.gatewayUrl,
    },
    providePrimeNGFromShell(loadCarelonPrimeNGConfig),
    DialogModule,
    PlatformService,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class MncInboundFaxModule implements DoBootstrap {
  constructor(
    private injector: Injector,
    private shellService: ShellService,
    private mfeService: InboundFaxMfeService
  ) { }

  ngDoBootstrap(): void {
    this.registerCustomElement('mnc-inbound-faxes', InboundFaxesComponent);

    this.shellService.registerMfeService('mnc-inbound-fax', this.mfeService);
  }

  private registerCustomElement(name: string, component: any) {
    if (customElements.get(name)) return;
    customElements.define(name, createCustomElement<any>(component, { injector: this.injector }));
  }
}
